import React from 'react'
import AirDrop from './AirDrop'
import { AirdropProvider } from '../../contexts/airDropContext'

const AirdropWrapper = () => {
  return (
    <AirdropProvider>
      <AirDrop />
    </AirdropProvider>
  )
}

export default AirdropWrapper
